import { render } from "./RemoveStaff.vue?vue&type=template&id=1c632aa4&ts=true"
import script from "./RemoveStaff.vue?vue&type=script&lang=ts"
export * from "./RemoveStaff.vue?vue&type=script&lang=ts"

import "./RemoveStaff.vue?vue&type=style&index=0&id=1c632aa4&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__